export default __webpack_public_path__ + "static/media/Mark-6-Suit-06.f790ee03.jpg";